export default "__VITE_ASSET__BQN_mrxh__"